import { serverTimestamp } from 'firebase/firestore';
import { buildWhatsAppLink } from './sendCheckQrWhatsApp';

const PUBLIC_APP_ORIGIN = (process.env.REACT_APP_PUBLIC_APP_URL || 'https://sdc-turismo.web.app')
  .replace(/\/$/, '');

export const createVoucherToken = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  return `${Date.now()}${Math.random().toString(36).slice(2, 14)}`;
};

export const buildVoucherLink = ({ token, origin }) => {
  if (!token) return '';
  const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const runtimeHostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLocalRuntime = runtimeHostname === 'localhost' || runtimeHostname === '127.0.0.1';
  const baseOrigin = (origin || (isLocalRuntime ? PUBLIC_APP_ORIGIN : runtimeOrigin) || PUBLIC_APP_ORIGIN)
    .replace(/\/$/, '');
  return `${baseOrigin}/voucher/${token}`;
};

export const buildVoucherWhatsAppMessage = ({ companyName, reservation, voucherLink }) => {
  const dateLabel = reservation?.checkInDate && reservation?.checkOutDate
    ? `Check-in: ${formatVoucherDate(reservation.checkInDate)} | Check-out: ${formatVoucherDate(reservation.checkOutDate)}`
    : `Data: ${formatVoucherDateTime(reservation?.date)}`;

  return [
    `Olá ${reservation?.clientName || 'cliente'}!`,
    `Seu voucher da ${companyName || 'empresa'} está pronto.`,
    `Serviço: ${reservation?.serviceName || '-'}`,
    reservation?.roomName ? `Quarto: ${reservation.roomName}` : '',
    dateLabel,
    `Participantes: ${reservation?.participants || 1}`,
    `Voucher: ${voucherLink}`
  ].filter(Boolean).join(' ');
};

export const buildVoucherWhatsAppLink = ({ phone, companyName, reservation, voucherLink }) => {
  return buildWhatsAppLink({
    phone,
    message: buildVoucherWhatsAppMessage({ companyName, reservation, voucherLink })
  });
};

export const buildPublicVoucherData = ({ token, companyId, companyData, reservationId, reservation }) => ({
  token,
  companyId,
  reservationId,
  companyName: companyData?.name || companyData?.companyName || reservation?.companyName || '',
  companyLogoUrl: companyData?.logoUrl || '',
  companyPrimaryColor: companyData?.primaryColor || '#2563eb',
  companySecondaryColor: companyData?.secondaryColor || companyData?.primaryColor || '#0f766e',
  clientName: reservation?.clientName || '',
  clientPhone: reservation?.clientPhone || '',
  serviceName: reservation?.serviceName || '',
  roomName: reservation?.roomName || '',
  date: reservation?.date || null,
  checkInDate: reservation?.checkInDate || null,
  checkOutDate: reservation?.checkOutDate || null,
  dailyCount: reservation?.dailyCount || 0,
  participants: reservation?.participants || 1,
  totalAmount: reservation?.totalAmount || 0,
  status: reservation?.status || 'pending',
  paymentStatus: reservation?.paymentStatus || 'unpaid',
  checkInStatus: reservation?.checkInStatus || 'pending',
  checkOutStatus: reservation?.checkOutStatus || 'pending',
  updatedAt: serverTimestamp()
});

export const formatVoucherDate = (value) => {
  if (!value) return '-';
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('pt-BR');
};

export const formatVoucherDateTime = (value) => {
  if (!value) return '-';
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
